<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <!-- <div>
        <el-form ref="elFormDom" inline :model="table.params" size="small">
          <el-form-item label="标签名称" prop="keyword">
            <el-input
              clearable
              v-model="table.params.keyword"
              placeholder="请输入"
              @keyup.enter.native.prevent="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div> -->
      <el-row style="margin-top: 10px">
        <el-button size="small" type="primary" @click="editRow">创建</el-button>
      </el-row>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        indexLabel="序号"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:company_total="{ row }">
          <el-button type="text" @click="viewList(row)">{{
            row.company_total
          }}</el-button>
        </template>
        <template v-slot:action="{ row }">
          <el-button type="text" @click="editRow(row)">修改</el-button>
          <el-button type="text" @click="deleteRow(row)">删除</el-button>
        </template>
      </VTable>
    </div>
    <edit ref="editRef" @update="getTable"></edit>
    <conectedCompany ref="conectedCompanyRef"></conectedCompany>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import edit from "./components/edit.vue";
import conectedCompany from "./components/conectedCompany.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  mixins: [mixinTable],
  components: {
    VTable,
    edit,
    conectedCompany,
  },
  data() {
    return {
      field: [
        { name: "name", label: "标签名称", hidden: false },
        { name: "company_total", label: "企业数量", hidden: false },
        {
          name: "create_time",
          label: "创建时间",
          hidden: false,
        },
        { name: "action", label: "操作", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          keyword: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http
        .get("/admin/company/tagList", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 重置查询条件
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    editRow(row = {}) {
      let dom = this.$refs.editRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    viewList(row) {
      let dom = this.$refs.conectedCompanyRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    deleteRow(row) {
      this.$confirm("是否删除该标签?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http.post("/admin/company/delTag", { id: row.id }).then((res) => {
          if (res.code === 1) {
            this.$message.success("删除成功");
            this.getTable();
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.t {
  font-size: 14px;
  line-height: 1.5;
  cursor: pointer;
}
.justify-between {
  justify-content: space-between;
}
.m {
  margin: 0 5px 0 35px;
}
</style>